import ProjectDetails from './ProjectDetails.vue';
import ProjectCustomers from './ProjectCustomers.vue';
import ProjectDevelopers from './ProjectDevelopers.vue';
import ProjectUsers from './ProjectUsers.vue';
import ProjectPlace from './ProjectPlace.vue';

export default {
    ProjectDetails, ProjectCustomers, ProjectDevelopers, ProjectUsers, ProjectPlace
}